import authenticate from '@/middleware/authenticate'

export default [
  {
    path: '/roles',
    name: 'role',
    meta: { middleware: authenticate },
    component: () => import('@/pages/security/role')
  }
]
